import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const InmateIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 48 48"
         fill="none"
         {...props}
      >
         <path
            d="M42.5645 46.123H6V42.123H42.5645V46.123Z"
            fill="currentColor"
         />
         <path
            d="M41.2305 34.123C41.8139 35.3679 42.2218 36.7119 42.4219 38.123H6.14258C6.34264 36.7119 6.75054 35.3679 7.33398 34.123H41.2305Z"
            fill="currentColor"
         />
         <path
            d="M28.6504 26.0527C32.4544 26.0528 35.9069 27.6093 38.4219 30.123H10.1426C12.6576 27.6093 16.11 26.0528 19.9141 26.0527H28.6504Z"
            fill="currentColor"
         />
         <path
            d="M24.2812 2.12305C30.2103 2.12305 35.0327 7.00092 35.0332 12.998C35.0332 18.9956 30.2106 23.875 24.2812 23.875C18.3519 23.875 13.5293 18.9956 13.5293 12.998C13.5298 7.00093 18.3522 2.12307 24.2812 2.12305Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default InmateIcon
